module.exports = __webpack_public_path__ + "static/media/bookopen.e8c7fe4e.svg";